import * as types from '../mutation-types'
import * as api from '../api'
import router from '../../router'
import moment from 'moment'
import _ from 'lodash'

let twelveHourFormat = 'hh:mm:ss a'
let twentyFourHourFormat = 'HH:mm:ss'

const state = {
  selected_day_schedule_id: 0,
  day_schedule: {
    day_schedule_id: 0,
    name: '',
    color: 'default'
  },
  day_schedule_item: {},
  day_schedule_item_at_interval: {},
  day_schedule_items_total_pages: 0,
  day_schedule_items_current_page: 0,
  day_schedules: [],
  day_schedules_received_timestamp: new Date(0),
  day_schedule_items: []
}

const getters = {
  selectedDayScheduleId: state => state.selected_day_schedule_id,
  singleDaySchedule: state => state.day_schedule,
  singleDayScheduleItem: state => state.day_schedule_item,
  singleDayScheduleItemAtInterval: state => state.day_schedule_item_at_interval,
  allDaySchedules: state => state.day_schedules,
  allDayScheduleItems: state => state.day_schedule_items,
  dayScheduleItemsTotalPages: state => state.day_schedule_items_total_pages,
  dayScheduleItemsCurrentPage: state => state.day_schedule_items_current_page
}

const actions = {
  changeSelectedDayScheduleId ({ commit }, selectedDayScheduleId) {
    commit(types.CHANGE_SELECTED_DAY_SCHEDULE_ID, Number(selectedDayScheduleId))
  },
  getDaySchedules ({ commit }) {
    api.instance.get('day_schedules')
      .then(function (response) {
        const daySchedules = response.data.day_schedules
        commit(types.RECEIVE_DAY_SCHEDULES, daySchedules)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getDaySchedule ({ commit }, dayScheduleId) {
    api.instance.get('day_schedules/' + dayScheduleId)
      .then(function (response) {
        const daySchedule = response.data.day_schedule
        commit(types.RECEIVE_DAY_SCHEDULE, daySchedule)
      })
  },
  getDayScheduleItems ({ commit }, params) {
    api.instance.get('day_schedule_items_by_day_schedule/' + params.dayScheduleId + '/' + params.zone_id + '/' + params.page)
      .then(function (response) {
        const dayScheduleItems = response.data.day_schedule_items
        for (let i = 0; i < dayScheduleItems.length; i++) {
          dayScheduleItems[i].schedule_time = moment(dayScheduleItems[i].schedule_time, [twentyFourHourFormat]).format(twelveHourFormat)
        }
        commit(types.RECEIVE_DAY_SCHEDULE_ITEMS, {
          dayScheduleItems: dayScheduleItems,
          page: response.data.page,
          totalPages: response.data.totalPages
        })
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getDayScheduleItem ({ commit, rootState }, dayScheduleItemId) {
    if (dayScheduleItemId === 0) {
      let tempScheduleTime = moment('7:00:00 am', twelveHourFormat).format(twelveHourFormat)

      if (rootState.appWide.current_server_time.hasOwnProperty('_isValid')) {
        tempScheduleTime = rootState.appWide.current_server_time.format(twelveHourFormat)
      }

      commit(types.RECEIVE_DAY_SCHEDULE_ITEM, {
        day_schedule_item_id: 0,
        day_schedule_id: 0,
        zones: [],
        sound_type_id: 1,
        sound_id: 0,
        sound: '',
        playlist_id: 0,
        playlist: '',
        schedule_time: '',
        description: '',
        schedule_time_formatted: tempScheduleTime
      })
    } else {
      api.instance.get('day_schedule_items/' + dayScheduleItemId)
        .then(function (response) {
          const dayScheduleItem = response.data.day_schedule_item
          let tempScheduleTime = moment(dayScheduleItem.schedule_time, [twentyFourHourFormat])
          dayScheduleItem.schedule_time_formatted = tempScheduleTime.format(twelveHourFormat)
          if (dayScheduleItem.sound_type_id === 1) {
            dayScheduleItem.sound = {
              value: dayScheduleItem.sound.sound_id,
              label: dayScheduleItem.sound.filename
            }
            dayScheduleItem.playlist_id = 0
            dayScheduleItem.playlist = ''
          } else if ([2, 3, 4].includes(dayScheduleItem.sound_type_id)) {
            dayScheduleItem.sound_id = 0
            dayScheduleItem.sound = ''
          }
          commit(types.RECEIVE_DAY_SCHEDULE_ITEM, dayScheduleItem)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  getDayScheduleItemAtInterval ({ commit, rootState }) {
    let tempScheduleTime = moment('7:00:00 am', twelveHourFormat)

    if (rootState.appWide.current_server_time.hasOwnProperty('_isValid')) {
      tempScheduleTime = rootState.appWide.current_server_time
    }

    commit(types.RECIEVE_DAY_SCHEDULE_ITEM_AT_INTERVAL, {
      day_schedule_id: 0,
      sound_type_id: 1,
      sound_id: 0,
      sound: '',
      zones: [],
      playlist_id: 0,
      playlist: '',
      start_time: tempScheduleTime.format(twelveHourFormat),
      end_time: moment(tempScheduleTime).add(2, 'h').format(twelveHourFormat),
      description: 'Preset Interval',
      interval: 30,
      interval_type: 'minute'
    })
  },
  addEditDaySchedule ({ rootGetters, commit }, daySchedule) {
    if (daySchedule.day_schedule_id === 0) {
      daySchedule.site_id = rootGetters.scopedSiteId
      api.instance.post('day_schedules', daySchedule)
        .then(function (response) {
          if (response.data.success === 'true') {
            daySchedule.day_schedule_id = response.data.day_schedule[0].day_schedule_id
            commit(types.ADD_DAY_SCHEDULE, daySchedule)
            router.push({ name: 'DayScheduler' })
          } else {
            alert(response.data.message)
          }
        })
    } else {
      api.instance.put('day_schedules/' + daySchedule.day_schedule_id, daySchedule)
        .then(function (response) {
          if (response.data.success === 'true') {
            commit(types.EDIT_DAY_SCHEDULE, daySchedule)
            router.push({ name: 'DayScheduler' })
          } else {
            alert(response.data.message)
          }
        })
    }
  },
  addEditDayScheduleItem ({ commit }, data) {
    let dayScheduleItem = data.day_schedule_item
    if (dayScheduleItem.zones.length > 0) {
      if (dayScheduleItem.sound_type_id === 1) {
        dayScheduleItem.sound_id = dayScheduleItem.sound.value
        dayScheduleItem.playlist_id = 0
        if (dayScheduleItem.sound === '' || dayScheduleItem.sound_id === 0 || dayScheduleItem.sound_id === '0') {
          alert('Please select a sound.')
          return
        }
      } else if ([2, 3, 4].includes(dayScheduleItem.sound_type_id) && dayScheduleItem.playlist_id === 0) {
        dayScheduleItem.sound_id = 0
        alert('Please select a playlist.')
        return
      }

      if (moment(dayScheduleItem.schedule_time_formatted, [twelveHourFormat])._isValid) {
        dayScheduleItem.schedule_time = moment(dayScheduleItem.schedule_time_formatted, [twelveHourFormat]).format(twentyFourHourFormat)
        if (dayScheduleItem.day_schedule_item_id === 0) {
          api.instance.post('day_schedule_items', {
            day_schedule_id: dayScheduleItem.day_schedule_id,
            zones: dayScheduleItem.zones,
            sound_type_id: dayScheduleItem.sound_type_id,
            sound_id: dayScheduleItem.sound_id,
            playlist_id: dayScheduleItem.playlist_id,
            schedule_time: dayScheduleItem.schedule_time,
            description: dayScheduleItem.description
          })
            .then(function (response) {
              if (response.data.success === 'true') {
                dayScheduleItem = response.data.day_schedule_item[0]

                data.day_schedule_item = dayScheduleItem
                commit(types.ADD_DAY_SCHEDULE_ITEM, data)

                if (data.to_continue) {
                  alert(response.data.message)
                } else {
                  router.push({ name: 'DayScheduler' })
                }
              } else {
                alert(response.data.message)
              }
            })
        } else {
          api.instance.put('day_schedule_items/' + dayScheduleItem.day_schedule_item_id, dayScheduleItem)
            .then(function (response) {
              if (response.data.success === 'true') {
                dayScheduleItem = response.data.day_schedule_item[0]
                commit(types.EDIT_DAY_SCHEDULE_ITEM, dayScheduleItem)
                router.push({ name: 'DayScheduler' })
              } else {
                alert(response.data.message)
              }
            })
        }
      } else {
        alert('Incorrect time format.')
      }
    } else {
      alert('Please select atleast one zone.')
    }
  },
  addDayScheduleItemAtInterval ({ commit }, dayScheduleItemAtInterval) {
    if (dayScheduleItemAtInterval.zones.length > 0) {
      if (dayScheduleItemAtInterval.sound_type_id === 1) {
        dayScheduleItemAtInterval.sound_id = dayScheduleItemAtInterval.sound.value
        dayScheduleItemAtInterval.playlist_id = 0
        if (dayScheduleItemAtInterval.sound === '' || dayScheduleItemAtInterval.sound_id === 0 || dayScheduleItemAtInterval.sound_id === '0') {
          alert('Please select a sound.')
          return
        }
      } else if ([2, 3, 4].includes(dayScheduleItemAtInterval.sound_type_id) && dayScheduleItemAtInterval.playlist_id === 0) {
        dayScheduleItemAtInterval.sound_id = 0
        alert('Please select a playlist.')
        return
      }

      if (moment(dayScheduleItemAtInterval.start_time, [twelveHourFormat])._isValid &&
        moment(dayScheduleItemAtInterval.end_time, [twelveHourFormat])._isValid) {
        dayScheduleItemAtInterval.start_time = moment(dayScheduleItemAtInterval.start_time, [twelveHourFormat]).format(twentyFourHourFormat)
        dayScheduleItemAtInterval.end_time = moment(dayScheduleItemAtInterval.end_time, [twelveHourFormat]).format(twentyFourHourFormat)
        api.instance.post('day_schedule_items_at_interval', {
          day_schedule_id: dayScheduleItemAtInterval.day_schedule_id,
          zones: dayScheduleItemAtInterval.zones,
          sound_type_id: dayScheduleItemAtInterval.sound_type_id,
          sound_id: dayScheduleItemAtInterval.sound_id,
          playlist_id: dayScheduleItemAtInterval.playlist_id,
          start_time: dayScheduleItemAtInterval.start_time,
          end_time: dayScheduleItemAtInterval.end_time,
          description: dayScheduleItemAtInterval.description,
          interval: dayScheduleItemAtInterval.interval,
          interval_type: dayScheduleItemAtInterval.interval_type
        })
          .then(function (response) {
            if (response.data.success === 'true') {
              router.push({ name: 'DayScheduler' })
            } else {
              alert(response.data.message)
            }
          })
      } else {
        alert('Incorrect time format.')
      }
    } else {
      alert('Please select at least one zone.')
    }
  },
  copyDaySchedule ({ commit }, params) {
    api.instance.post('/day_schedules/copy/' + params.dayScheduleIdToCopy, params.daySchedule)
      .then(function (response) {
        if (response.data.success === 'true') {
          params.daySchedule.day_schedule_id = response.data.day_schedule[0].day_schedule_id
          commit(types.ADD_DAY_SCHEDULE, params.daySchedule)
          router.push({ name: 'DayScheduler' })
        } else {
          alert(response.data.message)
        }
      })
  },
  clearDaySchedule ({ commit }, dayScheduleId) {
    api.instance.delete('/day_schedules/clear/' + dayScheduleId)
      .then(function (response) {
        if (response.data.success === 'true') {
          commit(types.RECEIVE_DAY_SCHEDULE_ITEMS, {
            dayScheduleItems: [],
            page: 0,
            totalPages: 0
          })
        }
      })
  },
  copyDayScheduleItemZone ({ commit }, params) {
    if (params.zone_id_copy_from !== params.zone_id_copy_to) {
      api.instance.post('/day_schedule_items/copy', params)
        .then(function (response) {
          if (response.data.success === 'true') {
            router.push({ name: 'DayScheduler' })
          } else {
            alert(response.data.message)
          }
        })
    } else {
      alert('Cannot copy to the same zone.')
    }
  },
  deleteDaySchedule ({ commit }, dayScheduleId) {
    api.instance.delete('day_schedules/' + dayScheduleId)
      .then(function (response) {
        if (response.data.success === 'true') {
          commit(types.DELETE_DAY_SCHEDULE, dayScheduleId)
        }
      })
  },
  deleteDayScheduleItem ({ commit }, dayScheduleItemId) {
    api.instance.delete('day_schedule_items/' + dayScheduleItemId)
      .then(function (response) {
        if (response.data.success === 'true') {
          commit(types.DELETE_DAY_SCHEDULE_ITEM, dayScheduleItemId)
        }
      })
  },
  deleteDayScheduleItemByIds ({ commit }, dayScheduleItemIds) {
    api.instance.post('day_schedule_items_by_ids', dayScheduleItemIds)
      .then(function (response) {
        if (response.data.success === 'true') {
          commit(types.DELETE_MULTIPLE_DAY_SCHEDULE_ITEMS, dayScheduleItemIds)
        }
      })
  }
}

const mutations = {
  [types.CHANGE_SELECTED_DAY_SCHEDULE_ID] (state, selectedDayScheduleId) {
    state.selected_day_schedule_id = selectedDayScheduleId
  },
  [types.RECEIVE_DAY_SCHEDULES] (state, daySchedules) {
    state.day_schedules = _.orderBy(daySchedules, 'name')
    state.day_schedules_received_timestamp = Date.now()
  },
  [types.RECEIVE_DAY_SCHEDULE] (state, daySchedule) {
    state.day_schedule = daySchedule
  },
  [types.ADD_DAY_SCHEDULE] (state, daySchedule) {
    state.day_schedules.push(daySchedule)
    state.day_schedule = {
      day_schedule_id: 0,
      name: '',
      color: 'default'
    }

    state.day_schedules = _.orderBy(state.day_schedules, 'name')
  },
  [types.EDIT_DAY_SCHEDULE] (state, daySchedule) {
    let dayScheduleToEdit = state.day_schedules.find(
      function (ele) {
        if (ele.day_schedule_id === daySchedule.day_schedule_id) {
          return true
        }
      }
    )
    let index = state.day_schedules.indexOf(dayScheduleToEdit)
    state.day_schedules[index] = daySchedule

    state.day_schedule = {
      day_schedule_id: 0,
      name: '',
      color: 'default'
    }
  },
  [types.DELETE_DAY_SCHEDULE] (state, dayScheduleId) {
    let dayScheduleToDelete = state.day_schedules.find(
      function (ele) {
        if (ele.day_schedule_id === dayScheduleId) {
          return true
        }
      }
    )
    let index = state.day_schedules.indexOf(dayScheduleToDelete)
    state.day_schedules.splice(index, 1)
  },
  [types.RECEIVE_DAY_SCHEDULE_ITEMS] (state, { dayScheduleItems, page, totalPages }) {
    state.day_schedule_items = dayScheduleItems
    state.day_schedule_items_current_page = page
    state.day_schedule_items_total_pages = totalPages
  },
  [types.RECEIVE_DAY_SCHEDULE_ITEM] (state, dayScheduleItem) {
    state.day_schedule_item = dayScheduleItem
  },
  [types.ADD_DAY_SCHEDULE_ITEM] (state, data) {
    state.day_schedule_items.push(data.day_schedule_item)
    if (data.to_continue) {
      let tempScheduleTime = moment('7:00:00 am', twelveHourFormat).format(twelveHourFormat)

      state.day_schedule_item.day_schedule_item_id = 0
      state.day_schedule_item.schedule_time = ''
      state.day_schedule_item.schedule_time_formatted = tempScheduleTime
      state.day_schedule_item.description = ''
      state.zones = []
    } else if (!data.to_continue) {
      state.day_schedule_item = {
        day_schedule_item_id: 0,
        day_schedule_id: 0,
        zones: [],
        sound_id: 0,
        schedule_time: '',
        schedule_time_formatted: moment('10:00:00 am', twelveHourFormat).format(twelveHourFormat)
      }
    }
  },
  [types.EDIT_DAY_SCHEDULE_ITEM] (state, dayScheduleItem) {
    let dayScheduleItemToEdit = state.day_schedule_items.find(
      function (ele) {
        if (ele.day_schedule_item_id === dayScheduleItem.day_schedule_item_id) {
          return true
        }
      }
    )
    let index = state.day_schedule_items.indexOf(dayScheduleItemToEdit)
    state.day_schedule_items[index] = dayScheduleItem
  },
  [types.DELETE_DAY_SCHEDULE_ITEM] (state, dayScheduleItemId) {
    let dayScheduleItemToDelete = state.day_schedule_items.find(
      function (ele) {
        if (ele.day_schedule_item_id === dayScheduleItemId) {
          return true
        }
      }
    )
    let index = state.day_schedule_items.indexOf(dayScheduleItemToDelete)
    state.day_schedule_items.splice(index, 1)
  },
  [types.RECIEVE_DAY_SCHEDULE_ITEM_AT_INTERVAL] (state, dayScheduleItemAtInterval) {
    state.day_schedule_item_at_interval = dayScheduleItemAtInterval
  },
  [types.DELETE_MULTIPLE_DAY_SCHEDULE_ITEMS] (state, dayScheduleItemIds) {
    for (let dayScheduleItemId of dayScheduleItemIds) {
      let dayScheduleItemToDelete = state.day_schedule_items.find(
        function (ele) {
          if (ele.day_schedule_item_id === dayScheduleItemId) {
            return true
          }
        }
      )
      let index = state.day_schedule_items.indexOf(dayScheduleItemToDelete)
      state.day_schedule_items.splice(index, 1)
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
